import { render, staticRenderFns } from "./ListStudentGroup.vue?vue&type=template&id=95a5f76c&scoped=true"
import script from "./ListStudentGroup.vue?vue&type=script&lang=js"
export * from "./ListStudentGroup.vue?vue&type=script&lang=js"
import style0 from "./ListStudentGroup.vue?vue&type=style&index=0&id=95a5f76c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a5f76c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a5f76c')) {
      api.createRecord('95a5f76c', component.options)
    } else {
      api.reload('95a5f76c', component.options)
    }
    module.hot.accept("./ListStudentGroup.vue?vue&type=template&id=95a5f76c&scoped=true", function () {
      api.rerender('95a5f76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/ViewStudentGroup/ListStudentGroup.vue"
export default component.exports